var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switcher",class:{
    'switcher--active': _vm.value,
    'switcher--readonly': _vm.readonly,
    'switcher--design-new': _vm.design === 'new'
  }},[_c('input',{staticClass:"switcher__input",attrs:{"disabled":_vm.disabled,"aria-label":_vm.ariaLabel || null,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"switcher__view"},[_c('span',{staticClass:"switcher__body"}),_c('span',{staticClass:"switcher__btn"})])
}]

export { render, staticRenderFns }